import "./Button.scss";

export const Button = ({ className, onClick, type, text }) => {
  return (
    <button type={type ? type : "button"} onClick={onClick} className={`checkout-btn py-3 ${className || ""}`}>
      {text}
    </button>
  );
};
